module.exports = __webpack_public_path__ + "img/pohled_z_venku_1.fa13bca4.jpg";